import React, {PropsWithChildren} from "react";

import * as S from './styles'
import {Navbar} from "../../components/Nav";
import {Footer} from "../../components/Footer";
import {useLocation} from "react-router-dom";


export const BaseLayout = ({children}: PropsWithChildren<unknown>) => {
    const location = useLocation();
    const isMainPage = location.pathname === '/';

    return (
        <S.Layout isMainPage={isMainPage}>
            <Navbar/>
            <S.Content>
                {children}
            </S.Content>
            <Footer/>
        </S.Layout>
    )
}